import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetTemplateDetailsRequest,
  GetTemplateDetailsResponse
} from "./interfaces/get-template-details";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getTemplateDetails(
  data: GetTemplateDetailsRequest,
  env: Environment
): Promise<GetTemplateDetailsResponse | Record<string, never>> {
  const url = `${getBaseUrl(env)}cxm/templates/${data.templateId}/details`;
  const header = await getHeader();
  const queryParams = new URLSearchParams({
    dealerId: data.dealerId.toString(),
    conversationType: data.conversationType,
    consumerId: data.consumerId,
    consumerRecordSystem: data.consumerRecordSystem
  });

  if (data.leadId) {
    queryParams.append("leadId", data.leadId.toString());
  }

  const response = await fetchWrapper.getAsync<GetTemplateDetailsResponse>(
    `${url}?${queryParams.toString()}`,
    header
  );

  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    console.error(
      `Error fetching template details for templateId: ${data.templateId}`,
      response?.error
    );
    return {}; // Return empty object on error
  }
}
